import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(i => (i + 1) % testimonials.length);
  const prev = () => setCurrentIndex(i => (i - 1 + testimonials.length) % testimonials.length);
  return <section className="bg-fil-card px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-186" data-mp="36wwiblj20f9q">
      <div className="max-w-3xl mx-auto" data-id="element-187" data-mp="31ybg5gk8rlin">
        <div className="text-center max-w-2xl mx-auto mb-8 sm:mb-12" data-id="element-188" data-mp="2x0tbi2d9bsgg">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight mb-4" data-id="element-189" data-mp="2x2w2aom8hpm8">
            Creaciones de mujeres que también comenzaron desde cero
          </h2>
          <p className="text-base sm:text-lg text-fil-taupe" data-id="element-190" data-mp="v8wvogk23wfv">
            Experiencias reales, proyectos reales y diferentes formas de
            disfrutar la filigrana.
          </p>
        </div>

        <div className="relative max-w-md mx-auto sm:max-w-lg" data-id="element-191" data-mp="h4dfase4k07c">
          <div className="overflow-hidden rounded-[1.75rem] bg-fil-bg border border-fil-beige" data-id="element-192" data-mp="m5b3pmpq9qha">
            <AnimatePresence mode="wait" data-id="element-193" data-mp="78k3xcc56cr5">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex flex-col h-full" data-id="element-194" data-mp="79le7elc2v7t">
                <div className="aspect-[4/3] bg-white" data-id="element-195" data-mp="q63c6dqrzrci">
                  <img src={testimonials[currentIndex].img} alt={`Proyecto de filigrana realizado por ${testimonials[currentIndex].name}`} className="w-full h-full object-cover" data-id="element-196" data-mp="v57kz39sfn2b" />
                </div>
                <div className="p-6 sm:p-8 flex flex-col flex-1 text-center items-center" data-id="element-197" data-mp="1nmjx84ghf45f">
                  <div className="flex gap-0.5 mb-4" aria-label="Valoración: 5 de 5" data-id="element-198" data-mp="1xiiswxhyhmj8">
                    {[...Array(5)].map((_, j) => <StarIcon key={j} size={16} className="text-fil-gold fill-fil-gold" aria-hidden="true" data-id="element-199" data-mp="1sinzam6sqiuh" data-mpi={j} />)}
                  </div>
                  <blockquote className="text-base sm:text-lg text-fil-text/80 leading-relaxed italic mb-6" data-id="element-200" data-mp="1ofhnz04tu1h5">
                    “{testimonials[currentIndex].text}”
                  </blockquote>
                  <div className="mt-auto pt-4 border-t border-fil-beige w-full" data-id="element-201" data-mp="1ekfy222q8vdi">
                    <p className="font-serif font-bold text-fil-text text-base sm:text-lg" data-id="element-202" data-mp="19rmuvimwpv3j">
                      {testimonials[currentIndex].name}
                    </p>
                    <p className="text-sm text-fil-taupe" data-id="element-203" data-mp="10s9sf9x7a6sb">
                      {testimonials[currentIndex].country}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button type="button" onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 sm:-translate-x-full sm:-ml-4 w-12 h-12 rounded-full bg-white border border-fil-beige text-fil-cocoa flex items-center justify-center hover:text-fil-terra transition-colors duration-150 ease-out shadow-md z-10" aria-label="Ver testimonio anterior" data-id="element-204" data-mp="qvn9iqofppsx">
            <ChevronLeftIcon size={20} data-id="element-205" data-mp="3gfdr2asetkta" />
          </button>
          <button type="button" onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 sm:translate-x-full sm:-mr-4 w-12 h-12 rounded-full bg-white border border-fil-beige text-fil-cocoa flex items-center justify-center hover:text-fil-terra transition-colors duration-150 ease-out shadow-md z-10" aria-label="Ver testimonio siguiente" data-id="element-206" data-mp="2jqo7mg14wk57">
            <ChevronRightIcon size={20} data-id="element-207" data-mp="2xj4756utu01d" />
          </button>

          <div className="flex justify-center gap-2 mt-6" data-id="element-208" data-mp="20yvfentw32yj">
            {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-2.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-fil-terra' : 'w-2.5 bg-fil-beige hover:bg-fil-rose'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-209" data-mp="250qfjp033aaq" data-mpi={idx} />)}
          </div>
        </div>
      </div>
    </section>;
}